import { render, staticRenderFns } from "./MonetizationAd.vue?vue&type=template&id=2eb68a8c"
import script from "./MonetizationAd.vue?vue&type=script&lang=js"
export * from "./MonetizationAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eb68a8c')) {
      api.createRecord('2eb68a8c', component.options)
    } else {
      api.reload('2eb68a8c', component.options)
    }
    module.hot.accept("./MonetizationAd.vue?vue&type=template&id=2eb68a8c", function () {
      api.rerender('2eb68a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/ads/MonetizationAd.vue"
export default component.exports